export class ReportProblem {
    user: string;
    email: string;
    errorLog: Array<string>;
    time: string;
    subject: string;
    description: string;
    severity: string;
}